import { useMounted } from 'hooks/useMounted';
/*
 * Wrap any JSX element with this component to prevent gatsby from rendering it as static html
 */
export const NoSSR = ({ children, Fallback = null }) => {
  const mounted = useMounted();
  if (mounted) {
    return children;
  }
  return Fallback;
};
